<template>
  <div>
    <PopUp
      :show="isOpen"
      class="change-brand-warning"
      @cancel="$emit('close')"
      @complete="$emit('accept')">
      <template v-slot:header>Change brand and discard filters?</template>
      <template v-slot:content>
        <div>
          Changing your brand will remove any existing filters.
          <br>
           Do you want to proceed?
        </div>
      </template>
      <template v-slot:cancel>Cancel</template>
      <template v-slot:complete>Yes, change brand</template>
    </PopUp>
  </div>
</template>

<script>
import { PopUp } from '@mikmak/components';
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    PopUp,
  },
};
</script>
<style scoped lang="scss">
.change-brand-warning {
  ::v-deep .overlay {
    z-index: 3;
  }
  ::v-deep .modal {
    z-index: 4;
  }
}

</style>
